import { deleteComponents, restoreComponents, moveElements } from "./components";
import { revertConfig, revertComponentConfig, revertManualGradingConfig } from "./configs";

export const  reverse = {
  deleteComponents: deleteComponents,
  restoreComponents: restoreComponents,
  revertConfig: revertConfig,
  revertComponentConfig: revertComponentConfig,
  moveElements: moveElements,
  revertManualGradingConfig: revertManualGradingConfig,
};
